<template>
  <footer class="footer-background py-4 mt-5">
    <img
      v-if="footerLogoSrc"
      class="mx-auto mt-3 mb-4 d-block"
      :alt="footerLogoAlt"
      :height="footerLogoHeight"
      :src="footerLogoSrc"
      :width="footerLogoWidth"
    >
    <div class="d-lg-flex justify-content-center text-center text-secondary">
      <div class="font-weight-bold pr-4 py-1">
        {{ phoneNumber }}
      </div>
      <div class="working-hours">
        <span class="working-hours__text py-1">Monday through Friday 7:00 am - 7:00 pm</span>
        <span class="px-3 working-hours__separator">-</span>
        <span class="working-hours__text py-1"> Saturday 9:00 am - 5:00 pm Mountain Time</span>
      </div>
    </div>
    <!-- Copyright notice -->
    <div class="text-center">
      <div class="text-secondary footer-links my-sm-3 my-md-1">
        <a
          href="https://www.autopay.com/terms-conditions"
          target="_blank"
          rel="noreferrer"
          class="brand-primary-color text-decoration-none"
        >Terms &amp; Conditions</a>
        <a
          href="https://www.autopay.com/privacy-policy"
          target="_blank"
          rel="noreferrer"
          class="brand-primary-color text-decoration-none"
        >Privacy Policy</a>
        <a
          href="https://www.autopay.com/legal-disclaimer"
          target="_blank"
          rel="noreferrer"
          class="brand-primary-color text-decoration-none"
        >Legal &amp; Disclaimers</a>
        <a
          href="https://www.autopay.com/terms"
          target="_blank"
          rel="noreferrer"
          class="brand-primary-color text-decoration-none"
        >Terms Of Use</a>
        <a
          href="https://www.autopay.com/privacy-rights"
          target="_blank"
          rel="noreferrer"
          class="brand-primary-color text-decoration-none"
        >Privacy Rights</a>
      </div>
      <span class="copyright-text">
        &copy; The Savings Group, Inc. All Rights Reserved.
      </span>
    </div>
  </footer>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        footerLogoAlt: 'brand/footerLogoAlt',
        footerLogoHeight: 'brand/footerLogoHeight',
        footerLogoSrc: 'brand/footerLogoSrc',
        footerLogoWidth: 'brand/footerLogoWidth',
        phoneNumber: 'brand/phoneNumber'
      })
    }
  };
</script>

<style lang="scss" scoped>
    .footer-background {
      background: var(--footer-background-color);
    }

    .footer-links {
      a {
        padding: 0 15px 0 10px;
        display: inline-block;
        position: relative;
        margin: 5px 0;
        &:after {
          content: '';
          position: absolute;
          display: block;
          width: 1.5px;
          height: 13px;
          background-color: var(--primary-color);
          top: 6px;
          right: 0;
        }
        &:last-child {
          &:after {
            content: none;
          }
        }
      }
    }

    .copyright-text {
      color: rgba(255, 255, 255, .6);
    }

    .working-hours {
      * {
        display: inline-block;
      }
    }

    @media screen and (max-width: 699px) {
      .working-hours {
        * {
          display: block;
        }
        &__separator {
          display: none!important;
        }
      }
    }
</style>
